module.exports = __webpack_public_path__ + "img/LogoQualiopi.402d9f6a.png";